import React, { Component } from 'react';
import { withTranslation } from "react-i18next";

import { Button, Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import WeChatQr from "./WeChatQr";

class ShareModal extends Component {

    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            popoverOpen: false
        };
    }

    toggle() {
        // TouchEvent is triggered at the same time as MouseClick event
        // 200ms is given for both triggers to happen and only then state is changed
        let newState = !this.state.popoverOpen;
        setTimeout(() => {
        this.setState({
                popoverOpen: newState,
        });
        }, 200)
    }

    notifyOnCopy = () => {
    }

    onShareLinkClick = (url) => {
        window.open(url);
        return false;
    }

    renderShareLink = (url, shareURL, title, mediaResource, imgSource) => {
        var src, srcset, urlToOpen
        if (imgSource === "osrammedia"){
                src = `https://www.osram.com/media/resource/40/${mediaResource}.jpg`;
                srcset = `${src} 1x,
                                https://www.osram.com/media/resource/80/${mediaResource}.jpg 2x,`;
                urlToOpen = url+shareURL
                            }
        if (imgSource === "dam"){ 
            const emailSubject = this.props.t("product.emailSubject")
            const emailBody = this.props.t("product.emailLine1") + this.props.t("product.emailLine2") +shareURL+" "+ this.props.t("product.emailLine3") + this.props.t("product.emailLine4")
            src = `https://media.osram.info/im/img/${mediaResource}/s,x,100,y,0/emailalsjpg.jpg`;
            srcset = "";
            urlToOpen = `mailto:automotive-lighting@osram.com.cn?subject=${emailSubject}&body=${emailBody}`
        }
        
        return (
            <div className="col-xs-3">
                {//eslint-disable-next-line
                } <a onClick={() => this.onShareLinkClick(urlToOpen)}  target="_blank" rel="noopener noreferrer" >
                {//eslint-disable-next-line
            }<img className="social-icon" src={src} srcSet={srcset} alt={ title } title={ title } />
                        </a>

                <p className="font-text-small" style={{ 'fontSize': '11.1px', 'lineHeight': '13.25px' }}>{ title }</p>
                    </div>
        )
    }

    renderMailLink = (url, zmp_id, order_nr, title, shareURL) => {
        var urlToOpen;
            const emailSubject = this.props.t("product.emailSubjectContactUs");
            const emailBody = this.props.t("product.emailLine1ContactUs") + this.props.t("product.emailLine2ContactUs") + this.props.t("product.emailLineProductContactUs") + zmp_id + this.props.t("product.emailLineOrderNoContactUs") + order_nr + this.props.t("product.emailLine3ContactUs") + this.props.t("product.emailLine4ContactUs");
            urlToOpen = `mailto:automotive-lighting@osram.com.cn?subject=${emailSubject}&body=${emailBody}`;

        return (
            <Button onClick={() => this.onShareLinkClick(urlToOpen)} className="vlrg-lightboxwtb link-btn orange-action-hover-btn btn-hover-fix" target="_blank" rel="noopener noreferrer" >{title}</Button>
        )
    };

    render() {
        var shareURL = window.location.href.split("?")[0];
        const { t } = this.props;
        
        if (this.state.popoverOpen && this.props.kind && this.props.zmp) {
            shareURL = shareURL.split("/#/")[0];
             shareURL=shareURL.replace(/#/,'')
            shareURL += `?kind=${this.props.kind}&zmp=${encodeURIComponent(this.props.zmp)}`
            var lang = this.props.getLang()
            if (lang === 'de_de') {
                shareURL += "&lang=de_DE"
            }
            if (this.props.partNumber) {
                shareURL += "&part=" + encodeURIComponent(this.props.partNumber);
            } else if (this.props.bulp && this.props.technology) {
                //we must have bulp and technology for others
                var tech=this.props.technology.replace(/ /g,'%20')
               
                shareURL += `&bulb=${this.props.bulp}&technology=${encodeURIComponent(tech)}`
                if (this.props.kbaNumber && this.props.kind === 1) {
                    shareURL += "&kba=" + this.props.kbaNumber + "&car=" +encodeURIComponent(this.props.carID);
                } else if (this.props.dropdowns && this.props.carID) {
                    var splinter = this.props.dropdowns.split("|")
                    shareURL += `&brand=${encodeURIComponent(splinter[0])}&model=${encodeURIComponent(splinter[1])}&year=${encodeURIComponent(splinter[2])}&type=${encodeURIComponent(splinter[3])}&car=${encodeURIComponent(this.props.carID)}`;
                }
            }
            //shareURL = encodeURIComponent(shareURL)
              shareURL=shareURL.replace(/ /,'%20')
            shareURL=shareURL.replace(/#/,'')

        }

        return (
            <div style={{'display': 'inline-block'}}>
                {this.renderMailLink('', this.props.zmp, this.props.ordernr, t("product.contactus"),shareURL)}
                <Button id="share-popover" type="button" className="vlrg-lightboxwtb link-btn orange-action-hover-btn btn-hover-fix">{t("app.share")}</Button>
                <Popover placement="bottom" isOpen={this.state.popoverOpen} target="share-popover" toggle={this.toggle} trigger="legacy">
                    <PopoverHeader className="popover-title">{t("app.share")}</PopoverHeader>
                    <PopoverBody className="popover-content">
                        <div className="social-layer">
                            <div className="row">
                                {/*{this.renderShareLink('', shareURL, "WeChat", "osram-dam-3377", "dam")}*/}
                                <WeChatQr url={decodeURIComponent(shareURL)}></WeChatQr>
                            </div>
                        </div>
                    </PopoverBody>
                </Popover>
            </div>
        )
    }
}

export default withTranslation()(ShareModal);
